import { translate } from "app/filters/i18nFilter";
import { ButtonContainer, StyledButton, StyledEmptyState } from "./StyledComponents";
import { SwTrack } from "app/services/SwTrack";
import { proNavigator } from "single-spa/react-app/ProNavigator";

const CtaButtons = () => {
    const createSegment = () => {
        SwTrack.all.trackEvent("Internal Link", "click", `segmentAnalysis/create new segment`);
        proNavigator.go("digitalsuite_segments-wizard");
    };

    return (
        <ButtonContainer>
            <StyledButton
                onClick={createSegment}
                type="flat"
            >
                {translate("segments.analysis.button.new.segment")}
            </StyledButton>
        </ButtonContainer>
    );
};

export const SegmentsStartPageEmptyState = () => {
    return (
        <StyledEmptyState
            title={translate("custom.segments.home.page.title")}
            subtitle={translate("custom.segments.home.page.subtitle")}
            CtaButtons={CtaButtons}
        />
    );
};
